import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { IFetchTotalsParams } from '../components/data-containers/BrowseEntities/shared/types';

export default function getTotalUrl(args: IFetchTotalsParams): string {
  const { entityType, entityIds } = args;

  const type = entityTypeToApiType(entityType);

  return `/api/${type}/${entityIds}?expand=none&showGrouped=true`;
}
